import * as types from "../types";


export const uploadedAuctionListRequest = ({accessToken,auction_group}) => ({
    type: types.FETCH_UPLOADED_AUCTION_REQUEST,
    payload:{
        accessToken,auction_group
    }
})

export const uploadedAuctionListSuccess = ({uploadedAuctionResult}) => ({
    type: types.FETCH_UPLOADED_AUCTION_SUCCESS,
    payload:{
        uploadedAuctionResult
    }
})

export const uploadedAuctionListFailure = ({error}) => ({
    type: types.FETCH_UPLOADED_AUCTION_FAILURE,
    payload:{
        error: error.message
    }
})